export default __webpack_public_path__ + "static/media/lateralImgLogin.72b3a07d.png";